import { render, staticRenderFns } from "./info-audit-dialog.vue?vue&type=template&id=5ffdd6af&scoped=true"
import script from "./info-audit-dialog.vue?vue&type=script&lang=js"
export * from "./info-audit-dialog.vue?vue&type=script&lang=js"
import style0 from "./info-audit-dialog.vue?vue&type=style&index=0&id=5ffdd6af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffdd6af",
  null
  
)

export default component.exports